import { render, staticRenderFns } from "./consumeList.vue?vue&type=template&id=f3c8b198&scoped=true"
import script from "./consumeList.vue?vue&type=script&lang=js"
export * from "./consumeList.vue?vue&type=script&lang=js"
import style0 from "./consumeList.vue?vue&type=style&index=0&id=f3c8b198&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c8b198",
  null
  
)

export default component.exports